'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ProjectCaseStudy } from '@/data/projects';
interface BlueprintOverlayProps {
  project: ProjectCaseStudy;
}
const BlueprintOverlay = t0 => {
  const $ = _c(32);
  const {
    project
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: "0.0000",
      y: "0.0000"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [coords, setCoords] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setCoords({
        x: Math.random().toFixed(4),
        y: Math.random().toFixed(4)
      });
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0
    };
    t5 = {
      opacity: 1
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute inset-0 opacity-[0.03] bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:60px_60px]" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute bottom-24 left-12 opacity-[0.01] select-none"><span className="font-mono text-[8px] text-primary uppercase tracking-[1em] block mb-2 font-bold">Structural Schema</span><h2 className="text-6xl md:text-[12rem] font-serif italic text-white leading-none">ARCHITECT</h2></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mb-8 border-b border-primary/20 pb-4"><span className="font-mono text-[9px] text-primary uppercase tracking-[0.3em]">Module Specifications</span></div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== project.adrs) {
    t9 = project.adrs.slice(0, 3).map(_temp);
    $[8] = project.adrs;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <div className="absolute right-8 top-[35%] w-64 space-y-4 hidden xl:block">{t8}{t9}</div>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p>LOAD_LEVEL: V.4.0.2</p>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== project.slug) {
    t12 = project.slug.toUpperCase();
    $[13] = project.slug;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12) {
    t13 = <p>STRATA: {t12}_BLUEPRINT</p>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== coords.x || $[18] !== coords.y) {
    t14 = <p>COORD: {coords.x}, {coords.y}</p>;
    $[17] = coords.x;
    $[18] = coords.y;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t13 || $[21] !== t14) {
    t15 = <div className="absolute top-32 right-8 text-right hidden md:block opacity-20"><div className="font-mono text-[8px] text-zinc-500 space-y-1">{t11}{t13}{t14}</div></div>;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="font-mono text-[9px] text-zinc-600 uppercase tracking-[0.3em]">SYS-INTEGRITY: OPTIMAL // ENCRYPTION: AES-256</div>;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== project.techStack) {
    t17 = project.techStack.slice(0, 3).map(_temp2);
    $[24] = project.techStack;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t17) {
    t18 = <div className="absolute bottom-8 left-12 right-12 flex justify-between items-end border-t border-white/5 pt-6 opacity-30">{t16}<div className="flex gap-6">{t17}</div></div>;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t10 || $[29] !== t15 || $[30] !== t18) {
    t19 = <motion.div initial={t4} animate={t5} className="fixed inset-0 z-50 pointer-events-none overflow-hidden">{t6}{t7}{t10}{t15}{t18}</motion.div>;
    $[28] = t10;
    $[29] = t15;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  return t19;
};
export default BlueprintOverlay;
function _temp(adr, i) {
  return <motion.div key={i} initial={{
    x: 100,
    opacity: 0
  }} animate={{
    x: 0,
    opacity: 1
  }} transition={{
    delay: 0.2 + i * 0.1
  }} className="p-4 border border-primary/10 bg-teal-950/40 backdrop-blur-md rounded-lg pointer-events-auto"><span className="font-mono text-[8px] text-primary/50 uppercase block mb-1">DATA-NODE-0{i + 1}</span><p className="text-[11px] text-zinc-300 font-serif italic mb-1">{adr.title}</p></motion.div>;
}
function _temp2(tech) {
  return <span key={tech} className="font-mono text-[9px] text-primary uppercase tracking-widest">[{tech}]</span>;
}